import { render, staticRenderFns } from "./ModalAjoutCategorie.vue?vue&type=template&id=86ac15fe&scoped=true&"
import script from "./ModalAjoutCategorie.vue?vue&type=script&lang=js&"
export * from "./ModalAjoutCategorie.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjoutCategorie.vue?vue&type=style&index=0&id=86ac15fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ac15fe",
  null
  
)

export default component.exports